// portfolio 에이전트 로컬 컴포넌트 라이브 샘플 — 실제 컴포넌트를 딥 경로로 import 해 목 데이터로 렌더한다.
// 갤러리는 apiClient 요청을 차단하므로 ThumbImg 썸네일은 fallback(빈 칸)으로 보인다(의도).
import { useState, type ReactNode } from 'react';
import type { SelectedPhoto } from '@indipia/agents-portfolio/src/types/portfolio.types';
import { ThumbImg } from '@indipia/agents-portfolio/src/components/ThumbImg';
import { SelectedStrip } from '@indipia/agents-portfolio/src/components/PhotoSelectGrid';

const INITIAL: SelectedPhoto[] = ['욕실', '주방', '거실'].map((spaceTag, i) => ({
  photoId: i + 1,
  url: `/photo/thumb/demo-${i + 1}.jpg`,
  spaceTag,
  siteId: 10,
  siteName: '강남 리모델링',
}));

function SelectedStripDemo() {
  const [selected, setSelected] = useState(INITIAL);
  return (
    <SelectedStrip selected={selected} onRemove={(id) => setSelected((s) => s.filter((p) => p.photoId !== id))} />
  );
}

export const demos: Record<string, () => ReactNode> = {
  ThumbImg: () => (
    <div className="flex flex-col gap-2">
      <ThumbImg
        url="/photo/thumb/demo-1.jpg"
        className="h-24 w-32 rounded-md object-cover"
        fallback={
          <div className="flex h-24 w-32 items-center justify-center rounded-md bg-surface-muted text-caption text-text-muted">
            fallback
          </div>
        }
      />
      <p className="text-caption text-text-secondary">API 차단 상태 → fallback</p>
    </div>
  ),
  SelectedStrip: () => <SelectedStripDemo />,
};
